import { OrderType } from 'constants/order';
import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

interface ProductDetailsStore {
  currentOrderType: OrderType;
  hasUserChangedOrderType: boolean;
  setCurrentOrderType: (orderType: OrderType) => void;
  setHasUserChangedOrderType: (value: boolean) => void;
}

type ProductDetailsPersist = (
  config: StateCreator<ProductDetailsStore>,
  options: PersistOptions<ProductDetailsStore>
) => StateCreator<ProductDetailsStore>;

/**
 * Zustand Store to manage the current order type in the product details page
 */
export const useProductDetailsStore = create<ProductDetailsStore>(
  (persist as ProductDetailsPersist)(
    (set) => ({
      currentOrderType: OrderType.ONE_OFF,
      hasUserChangedOrderType: false,
      setCurrentOrderType: (orderType: OrderType) => set({ currentOrderType: orderType }),
      setHasUserChangedOrderType: (value: boolean) => set({ hasUserChangedOrderType: value }),
    }),
    {
      name: 'pd:default-order-type',
    }
  )
);
